import { store } from "../Redux/store";
import { snack } from "./SnackbarUtilsConfigurator";
const FileDownload = require('js-file-download');


export const DownloadReactState =  () => {
    let storeData = store.getState();
    FileDownload(JSON.stringify(storeData.ViewTravel), `${new Date().getTime()}-${window.location.hostname}.txt`)
};


export const DownloadReactStatesdsd =  (storeData) => {
     FileDownload(JSON.stringify(storeData), `${new Date().getTime()}-${window.location.hostname}.txt`)
};
